export enum BillingsPlanEntryTaxiDriverAddRequestContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverAddRequestBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverAddRequestBonusContributionOther = {
  type: BillingsPlanEntryTaxiDriverAddRequestContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionBeingLate =
  {
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionOther = {
  type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverAddRequestBonusContribution =
  | BillingsPlanEntryTaxiDriverAddRequestBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverAddRequestBonusContributionOther;

export type BillingsPlanEntryTaxiDriverAddRequestPenaltyContribution =
  | BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverAddRequestContribution =
  | BillingsPlanEntryTaxiDriverAddRequestBonusContribution
  | BillingsPlanEntryTaxiDriverAddRequestPenaltyContribution
  | BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverAddRequestBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsPlanEntryTaxiDriverAddRequestBody = {
  billingNodes: BillingsPlanEntryTaxiDriverAddRequestBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverAddRequestContribution[];
};

type BillingsPlanEntryTaxiDriverAddRequest = {
  planEntryId: string;
  billingNodes: BillingsPlanEntryTaxiDriverAddRequestBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverAddRequestContribution[];
};

export default BillingsPlanEntryTaxiDriverAddRequest;
